const CryptoJS = require('crypto-js');

const kInfoBasis = '@3#fked8*w829Y&^DsTERS#@%$DRD$_()0jH66dg33RT%^^';

export function kInfoUnpack(keyStr, data) {
  keyStr = kInfoBasis + (keyStr || '');
  let unparsed = CryptoJS.AES.decrypt(data, keyStr).toString(CryptoJS.enc.Utf8);
  if (!unparsed) return unparsed;
  return JSON.parse(unparsed);
}
